import React from 'react';
import { Chip as SharedChip } from '@repo/common';
import {
  KST,
  formatClock,
  formatDay,
  tzOffsetLabel,
  zonedHourParts,
  zonedToDate,
} from './model/time';

/** Pre-join 과 Profile 이 같이 쓰는 입력값 — 작업 시간·툴·스택·셀프체크 */

// 신청폼(TwoDaysApply)의 툴 선택지를 users.tools[] · stack[] 으로 나눈 것
export const CHIP_GROUPS = [
  {
    key: 'tools',
    title: 'Tools',
    items: [
      'Figma',
      'Notion',
      'Jira',
      'Slack',
      'Google Workspace',
      'Canva',
      'Google Analytics',
      'Meta Ads',
    ],
  },
  {
    key: 'stack',
    title: 'Stack',
    items: ['React', 'Next.js', 'TypeScript', 'Node.js', 'Spring', 'Python', 'Flutter'],
  },
];
export const STACK_ITEMS = CHIP_GROUPS[1].items;

export const TIME_ZONES = [
  'Asia/Seoul',
  'Asia/Tokyo',
  'Asia/Ho_Chi_Minh',
  'Asia/Bangkok',
  'Asia/Jakarta',
  'Asia/Kolkata',
  'Asia/Dhaka',
  'Europe/London',
  'Europe/Berlin',
  'America/New_York',
  'America/Los_Angeles',
];

export const tzLabel = (tz) => `(${tzOffsetLabel(tz)}) ${tz.split('/').pop().replace(/_/g, ' ')}`;

/** 본인 시간대의 작업 시간을 KST 로 — 자정을 넘기면 다음 날로 */
export const toKstRange = (tz, from, to, at) => {
  const p = zonedHourParts(at, tz);
  const [fh, fm] = from.split(':').map(Number);
  const [th, tm] = to.split(':').map(Number);
  const start = zonedToDate(tz, p.y, p.m, p.d, fh, fm);
  let end = zonedToDate(tz, p.y, p.m, p.d, th, tm);
  if (end <= start) end = new Date(end.getTime() + 24 * 60 * 60 * 1000);
  return {
    text: `${formatClock(start, KST)} – ${formatClock(end, KST)}`,
    crossesDay: formatDay(start, KST) !== formatDay(new Date(end.getTime() - 60000), KST),
  };
};

/** 여러 구간을 KST 로 — '10:00 – 12:00, 15:00 – 20:00' · 하나라도 다음 날로 넘어가면 crossesDay */
export const toKstRanges = (tz, slots, at) => {
  const list = slots.map((x) => toKstRange(tz, x.from, x.to, at));
  return {
    text: list.map((x) => x.text).join(', '),
    crossesDay: list.some((x) => x.crossesDay),
  };
};

/** 저장된 사람 값에서 구간 목록 — 여러 구간이 없으면 예전 한 구간 */
export const slotsFrom = (v, fallback = { from: '09:00', to: '18:00' }) =>
  v?.availableSlots?.length
    ? v.availableSlots.map((x) => ({ from: x.from, to: x.to }))
    : [
        {
          from: v?.availableFrom || fallback.from,
          to: v?.availableTo || fallback.to,
        },
      ];

export const Chip = ({ on, onClick, children }) => (
  <SharedChip
    type='outline'
    aria-pressed={on}
    onClick={onClick}
    state={on ? 'selected' : 'default'}
    size='m'
    hideIcon
  >
    {children}
  </SharedChip>
);

export const formatTaken = (iso) =>
  new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric' }).format(
    new Date(iso),
  );
